module.exports = __webpack_public_path__ + "img/fitz_roy_ba_list.3fe60ba5.jpg";